import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { useAuth } from '../../hooks/useAuth';
import StatusBadge from './StatusBadge';
import MobileMenu from './MobileMenu';
import logoSvg from '../../assets/logo.svg';

export default function Navbar() {
  const { user, logout } = useAuth();
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  // Detectar cambios de ruta
  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleRouteChange);

    // También detectar cambios cuando se navega programáticamente
    const originalPushState = history.pushState;
    history.pushState = function(...args) {
      originalPushState.apply(history, args);
      handleRouteChange();
    };

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      history.pushState = originalPushState;
    };
  }, []);

  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    route('/login');
  };

  const handleLogoClick = () => {
    route('/');
  };

  // Definir links de navegación según el estado del usuario
  const getNavigationLinks = () => {
    const links = [];

    if (user.status === 'active') {
      links.push(
        { label: 'Directorio', path: '/', icon: '📂' },
        { label: 'Mi Perfil', path: '/mi-perfil', icon: '👤' }
      );
    } else if (user.status === 'approved_pending_payment') {
      links.push({ label: 'Instrucciones de Pago', path: '/pago-pendiente', icon: '💳' });
    }
    // Estados registered, pending_approval, rejected, inactive → sin links

    return links;
  };

  const navLinks = getNavigationLinks();

  return (
    <nav class="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
          {/* Logo */}
          <div class="flex items-center">
            <button
              onClick={handleLogoClick}
              class="flex items-center focus:outline-none focus:ring-2 focus:ring-orange-500 rounded-md px-2 py-1"
            >
              <img src={logoSvg} alt="FIT-Book" class="h-10" />
            </button>
          </div>

          {/* Desktop Navigation */}
          <div class="hidden md:flex md:items-center md:space-x-6">
            {/* Navigation Links */}
            {navLinks.length > 0 && (
              <div class="flex items-center space-x-1">
                {navLinks.map((link) => (
                  <button
                    key={link.path}
                    onClick={() => route(link.path)}
                    class={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      currentPath === link.path
                        ? 'bg-orange-100 text-orange-900'
                        : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    }`}
                  >
                    <span class="mr-1">{link.icon}</span>
                    {link.label}
                  </button>
                ))}
              </div>
            )}

            {/* User Info */}
            <div class="flex items-center space-x-3 pl-4 border-l border-gray-200">
              <svg class="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <StatusBadge status={user.status} />
            </div>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              class="flex items-center px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
            >
              <svg class="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Salir
            </button>
          </div>

          {/* Mobile Menu */}
          <MobileMenu
            links={navLinks}
            userStatus={user.status}
            onLogout={handleLogout}
            currentPath={currentPath}
          />
        </div>
      </div>
    </nav>
  );
}
